module.exports = __webpack_public_path__ + "app/components/customers/customers.view.html";